var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"intro_banner"},[_c('div',{staticClass:"inner"},[_c('div',{staticClass:"left"},[(_vm.title)?_c('p',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._v(" "),(_vm.arrow)?_c('a',{staticClass:"arrow",attrs:{"href":_vm.arrowUrl}},[_c('img',{attrs:{"src":_vm.arrow,"alt":_vm.title}})]):_vm._e()]),_vm._v(" "),(_vm.content)?_c('div',{staticClass:"right"},[_c('h2',[_vm._v(_vm._s(_vm.content))])]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /home/forge/leonaudio.stagingwebsite.dev/web/app/themes/texture/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/home/forge/leonaudio.stagingwebsite.dev/web/app/themes/texture/node_modules/vue-loader/lib?{}!./scripts/vue/PageBanner.vue?vue&type=template&id=03cac8d3&scoped=true&
// module id = 89
// module chunks = 0